var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoScreeningsurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.333 22.668C29.9103 22.668 32 24.7576 32 27.335C31.9998 29.9121 29.9102 32.001 27.333 32.001H8.66699C6.08978 32.001 4.00018 29.9121 4 27.335C4 24.7576 6.08967 22.668 8.66699 22.668H27.333ZM27.333 4C29.9103 4 32 6.08967 32 8.66699C31.9998 11.2378 29.9209 13.3217 27.3525 13.332C29.921 13.3424 32 15.4281 32 17.999C31.9998 20.5762 29.9102 22.665 27.333 22.665H8.66699C6.08978 22.665 4.00018 20.5762 4 17.999C4 15.4284 6.07844 13.3429 8.64648 13.332C6.07856 13.3212 4.00018 11.2374 4 8.66699C4 6.08967 6.08967 4 8.66699 4H27.333Z",
    fill: "#85DE18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoScreeningsurvey);
export default __webpack_public_path__ + "static/media/Ico_Screening survey.7f24518a5c368d5917388d1dda07472d.svg";
export { ForwardRef as ReactComponent };